/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  audiencePreview(payload) {
    return axios.post(`${this.url}/audience_preview`, payload);
  }

  recipients(id, params) {
    return axios.get(`${this.url}/${id}/recipients`, { params });
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  refreshTemplate(id) {
    return axios.post(`${this.url}/${id}/refresh_template`);
  }

  launch(id, payload = {}) {
    return axios.post(`${this.url}/${id}/launch`, payload);
  }
}

export default new CampaignsAPI();
